import React, { Component } from "react"
import Header from "./../../components/user/common/Header"
import PageTitle from "./../../components/user/common/PageTitle"
import Footer from "./../../components/common/Footer"
import store from "./../../store/index"
import axios from "axios"
import { toast } from "react-toastify"
import { connect } from "react-redux"
import { setLoading } from "./../../store/reducers/global-reducer"
import SpinnerLoader from "./../../components/common/SpinnerLoader"
import DataTable from "react-data-table-component"
import SortIcon from "@material-ui/icons/ArrowDownward"
import DataTableExtensions from "react-data-table-component-extensions"
import "react-data-table-component-extensions/dist/index.css"
import "../../assets/css/my-quotes.css"
import Modal from "react-bootstrap/Modal"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Button from "react-bootstrap/Button"
import Badge from "react-bootstrap/Badge"
import { Helmet } from "react-helmet"
import config from "../../config.json"
import resolveFileUrl from "../../helpers/resolve-file-url"
import Box from "@mui/material/Box"
import Stepper from "@mui/material/Stepper"
import Step from "@mui/material/Step"
import StepLabel from "@mui/material/StepLabel"
import QuoteRequestModal from "../../components/user/common/QuoteRequestModal"
import QuoteTimelineModal from "../../components/user/common/QuoteTimelineModal"
import { withRouter } from "react-router-dom"

class MyQuotes extends Component {
  constructor(props) {
    super(props)
    const { dispatch } = props
    this.dispatch = dispatch
    this.authInfo = store.getState().auth.authInfo
    this.userInfo = store.getState().auth.userInfo
    this.state = {
      data: [],
      loading: true,
      error: null,
      showModal: false,
      showResponseModal: false,
      showEditModal: false,
      showTimelineModal: false,
      showRejectModal: false,
      selectedRowData: null,
      statusFilter: "all",
      typeFilter: "all",
      actionLoading: false,
      rejectionReason: "",
      counters: {
        pending: 0,
        responded: 0,
        accepted: 0,
        rejected: 0,
        expired: 0,
      },
    }
  }

  componentDidMount() {
    this.getQuoteDetails()
  }

  // Add this new method to get URL parameters
  getUrlParameter = (name) => {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get(name)
  }

  // Add this new method to remove URL parameter
  removeUrlParameter = (name) => {
    const url = new URL(window.location)
    url.searchParams.delete(name)
    window.history.replaceState({}, document.title, url.pathname + url.search)
  }

  getQuoteDetails = () => {
    this.setState({ loading: true })

    const requestData = {
      status: this.state.statusFilter !== "all" ? this.state.statusFilter : undefined,
      type: this.state.typeFilter !== "all" ? this.state.typeFilter : undefined,
      count: {
        page: 1,
        limit: 50,
        skip: 0,
      },
      sorting: {
        sort_type: "date",
        sort_val: "desc",
      },
    }

    axios
      .post(`user/quotes/${this.authInfo.id}`, requestData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${this.authInfo.token}`,
        },
      })
      .then((response) => {
        if (response.data.status) {
          const { quotes, counters } = response.data.data
          this.setState({
            data: quotes,
            counters: counters || {},
            loading: false,
          }, () => {
            // Check for quoteId parameter after data is loaded
            this.checkForQuoteIdParameter()
          })
        } else {
          this.setState({ data: [], loading: false })
        }
      })
      .catch((error) => {
        console.error("Error fetching quotes:", error)
        if (error.response && error.response.data.status === false) {
          toast.error(error.response.data.message)
        }
        this.setState({ loading: false })
      })
  }

  // Add this new method to check for quoteId parameter and open modal
  checkForQuoteIdParameter = () => {
    const quoteId = this.getUrlParameter('quoteId')
    if (quoteId && this.state.data.length > 0) {
      const foundQuote = this.state.data.find(quote => quote._id === quoteId)
      if (foundQuote) {
        this.setState({
          selectedRowData: foundQuote,
          showModal: true
        })
        // Remove the parameter from URL to clean it up
        this.removeUrlParameter('quoteId')
        //toast.success('Quote details opened successfully!')
      } else {
        //toast.error('Quote not found or you do not have permission to view it.')
        this.removeUrlParameter('quoteId')
      }
    }
  }

  handleDetailsClick = (row) => {
    this.setState({ selectedRowData: row, showModal: true })
  }

  handleResponseClick = (row) => {
    if (row.status === "responded") {
      this.setState({ selectedRowData: row, showResponseModal: true })
    }
  }

  handleEditClick = (row) => {
    if (row.status === "pending" && !row.isFinal && row.priceEditableByBuyer) {
      this.setState({ selectedRowData: row, showEditModal: true })
    }
  }

  handleTimelineClick = (row) => {
    this.setState({ selectedRowData: row, showTimelineModal: true })
  }

  handleAcceptQuote = async (quoteId) => {
    this.setState({ actionLoading: true })

    try {
      const response = await axios.put(
        `user/quote/${quoteId}/accept`,
        {
          buyerId: this.authInfo.id,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${this.authInfo.token}`,
          },
        },
      )

      if (response.data.status) {
        toast.success("Quote accepted successfully! Redirecting to checkout...")
        this.setState({ showResponseModal: false })

        // Redirect to checkout or project page
        const { order, project } = response.data.data
        console.log(order)
        if (order && order.projectId) {
          this.props.history.push(`/checkout/milestones/${order.projectId}`)
        } else {
          // Refresh the data
          this.getQuoteDetails()
        }
      } else {
        toast.error(response.data.message || "Failed to accept quote")
      }
    } catch (error) {
      console.error("Error accepting quote:", error)
      toast.error(error.response?.data?.message || "Failed to accept quote")
    } finally {
      this.setState({ actionLoading: false })
    }
  }

  handleRejectClick = (quoteId) => {
    this.setState({
      showRejectModal: true,
      rejectionReason: "",
      selectedRowData: this.state.data.find((quote) => quote._id === quoteId),
    })
  }

  handleRejectQuote = async (quoteId, reason = "") => {
    this.setState({ actionLoading: true })

    try {
      const response = await axios.put(
        `user/quote/${quoteId}/reject`,
        {
          buyerId: this.authInfo.id,
          reason: reason,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${this.authInfo.token}`,
          },
        },
      )

      if (response.data.status) {
        toast.success("Quote rejected successfully!")
        this.setState({
          showResponseModal: false,
          showRejectModal: false,
          rejectionReason: "",
        })
        this.getQuoteDetails() // Refresh the data
      } else {
        toast.error(response.data.message || "Failed to reject quote")
      }
    } catch (error) {
      console.error("Error rejecting quote:", error)
      toast.error(error.response?.data?.message || "Failed to reject quote")
    } finally {
      this.setState({ actionLoading: false })
    }
  }

  handleConfirmReject = () => {
    if (this.state.rejectionReason.trim().length < 5) {
      toast.error("Please provide a reason for rejection (minimum 5 characters)")
      return
    }
    this.handleRejectQuote(this.state.selectedRowData._id, this.state.rejectionReason)
  }

  handleCancelReject = () => {
    this.setState({
      showRejectModal: false,
      rejectionReason: "",
    })
  }

  getStatusBadge = (status, isFinal) => {
    const statusConfig = {
      pending: { variant: "warning", text: "Pending" },
      responded: { variant: "info", text: "Responded" },
      accepted: { variant: "success", text: "Accepted" },
      rejected: { variant: "danger", text: "Rejected" },
      expired: { variant: "secondary", text: "Expired" },
    }

    const config = statusConfig[status] || { variant: "secondary", text: status }

    return (
      <div className="my-quotes-status-badges">
        <Badge bg={config.variant} className="my-quotes-status-badge">
          {config.text}
        </Badge>
        {isFinal && (
          <Badge bg="secondary" className="my-quotes-status-badge my-quotes-status-badge-final">
            Final
          </Badge>
        )}
      </div>
    )
  }

  getQuoteSteps = (status) => {
    const steps = ["Request Sent", "Seller Response", "Completed"]
    let activeStep = 0

    switch (status) {
      case "pending":
        activeStep = 0
        break
      case "responded":
        activeStep = 1
        break
      case "accepted":
      case "rejected":
        activeStep = 2
        break
      default:
        activeStep = 0
    }

    return { steps, activeStep }
  }

  handleStatusFilter = (status) => {
    this.setState({ statusFilter: status }, () => {
      this.getQuoteDetails()
    })
  }

  handleTypeFilter = (type) => {
    this.setState({ typeFilter: type }, () => {
      this.getQuoteDetails()
    })
  }

  data_column = [
    {
      name: "Quote ID",
      selector: (row) => row.quoteCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <img
            src={row.productId?.featuredImage || row.serviceId?.featuredImage || "/placeholder.svg"}
            alt="Item"
            style={{ width: "40px", height: "40px", objectFit: "cover", marginRight: "10px", borderRadius: "4px" }}
          />
          <div>
            <div style={{ fontWeight: "500", fontSize: "14px" }}>
              {row.productId?.name || row.serviceId?.name || "N/A"}
            </div>
            <small className="text-muted">{row.type}</small>
          </div>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Seller",
      selector: (row) => row.sellerId?.name || "N/A",
      sortable: true,
      width: "120px",
    },
    {
      name: "Status",
      cell: (row) => this.getStatusBadge(row.status, row.isFinal),
      sortable: true,
      width: "120px",
    },
    {
      name: "Your Price",
      cell: (row) => <div>{row.requestDetails?.suggestedPrice ? `$${row.requestDetails.suggestedPrice}` : "-"}</div>,
      width: "100px",
    },
    {
      name: "Response Price",
      cell: (row) => <div>{row.response?.price ? `$${row.response.price}` : "-"}</div>,
      width: "120px",
    },
    {
      name: "Request Date",
      cell: (row) => {
        const date = new Date(row.createdAt).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
        return <div>{date}</div>
      },
      sortable: true,
      width: "120px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="my-quotes-row-actions">
          <button
            onClick={() => this.handleDetailsClick(row)}
            className="btn custom_btn btn_yellow_bordered btn-sm my-quotes-action-btn"
          >
            Details
          </button>
          {row.status === "responded" && (
            <button
              onClick={() => this.handleResponseClick(row)}
              className="btn custom_btn btn_yellow btn-sm my-quotes-action-btn"
            >
              Review
            </button>
          )}
          <button
            onClick={() => this.handleTimelineClick(row)}
            className="btn custom_btn btn_yellow_bordered btn-sm my-quotes-action-btn"
          >
            Timeline
          </button>
          {row.status === "pending" && !row.isFinal && row.priceEditableByBuyer && (
            <button
              onClick={() => this.handleEditClick(row)}
              className="btn custom_btn btn_yellow_bordered btn-sm my-quotes-action-btn"
            >
              Edit
            </button>
          )}
        </div>
      ),
      width: "200px",
    },
  ]

  render() {
    const { data, loading, selectedRowData, actionLoading, statusFilter, typeFilter, counters } = this.state
    const userName = this.userInfo?.name || "User"

    return (
      <React.Fragment>
        <Helmet>
          <title>{"My Quotes - Pay Earth"}</title>
        </Helmet>
        {loading === true ? <SpinnerLoader /> : ""}
        {actionLoading === true ? <SpinnerLoader /> : ""}
        <Header />
        <PageTitle title="My Quotes" />
        <section className="inr_wrap orders_page my-quotes-page">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="cart wishlist">
                  <div className="cart_wrap">
                    <div className="items_incart d-flex justify-content-between align-items-center">
                      <span className="text-uppercase">
                        {data.length} QUOTE{data.length !== 1 ? "S" : ""} FOUND
                      </span>
                      <div className="my-quotes-filters-scroll">
                        <div className="my-quotes-filters-row d-flex gap-2 align-items-center">
                        {/* Status Filter Buttons */}
                        <div className="btn-group" role="group">
                          <button
                            type="button"
                            className={`btn btn-sm ${statusFilter === "all" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleStatusFilter("all")}
                          >
                            All ({Object.values(counters).reduce((a, b) => a + b, 0)})
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${statusFilter === "pending" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleStatusFilter("pending")}
                          >
                            Pending ({counters.pending || 0})
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${statusFilter === "responded" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleStatusFilter("responded")}
                          >
                            Responded ({counters.responded || 0})
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${statusFilter === "accepted" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleStatusFilter("accepted")}
                          >
                            Accepted ({counters.accepted || 0})
                          </button>
                        </div>

                        {/* Type Filter */}
                        <div className="btn-group" role="group">
                          <button
                            type="button"
                            className={`btn btn-sm ${typeFilter === "all" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleTypeFilter("all")}
                          >
                            All Types
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${typeFilter === "product" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleTypeFilter("product")}
                          >
                            Products
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${typeFilter === "service" ? "btn_yellow" : "btn-outline-secondary"}`}
                            onClick={() => this.handleTypeFilter("service")}
                          >
                            Services
                          </button>
                        </div>

                        <button
                          type="button"
                          className="btn custom_btn btn_yellow"
                          onClick={() => window.history.back()}
                        >
                          Back
                        </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cart_list cart_wrap pb-5">
                    <div className="my-quotes-table-scroll">
                      <DataTableExtensions columns={this.data_column} data={data}>
                        <DataTable
                          pagination
                          noHeader
                          highlightOnHover
                          defaultSortField="createdAt"
                          sortIcon={<SortIcon />}
                          defaultSortAsc={false}
                          noDataComponent={
                            <div className="text-center py-4">
                              <p>No quotes found. Start by requesting quotes on products or services!</p>
                            </div>
                          }
                        />
                      </DataTableExtensions>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />

        {/* Quote Details Modal */}
        <Modal
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
          dialogClassName="modal-90w"
          aria-labelledby="quote-details-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="quote-details-modal">Quote Request Details</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}>
            {selectedRowData && (
              <div>
                <div className="d-flex flex-row justify-content-between align-items-start bg-light w-100 p-4">
                  <div className="w-100">
                    <h4 className="fw-bold my-2 text-dark">{userName}</h4>
                    <h6 className="fw-bold text-secondary mb-1">Quote ID: {selectedRowData.quoteCode || ""}</h6>
                    <div className="mt-2">{this.getStatusBadge(selectedRowData.status, selectedRowData.isFinal)}</div>
                  </div>
                </div>

                <div className="p-4 cart-mob-p0">
                  <Row className="mb-4">
                    <Col md={6}>
                      <div className="fw-bold mb-3">Item Details:</div>
                      <div className="d-flex align-items-center mb-3">
                        <img
                          src={
                            selectedRowData.productId?.featuredImage ||
                            selectedRowData.serviceId?.featuredImage ||
                            "/placeholder.svg"
                          }
                          alt="Item"
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                            marginRight: "15px",
                            borderRadius: "8px",
                          }}
                        />
                        <div>
                          <h6 className="mb-1">
                            {selectedRowData.productId?.name || selectedRowData.serviceId?.name || "N/A"}
                          </h6>
                          <p className="mb-1 text-muted">{selectedRowData.type}</p>
                          <p className="mb-0 fw-bold">
                            Original Price: $
                            {selectedRowData.productId?.price || selectedRowData.serviceId?.charges || "N/A"}
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="fw-bold mb-3">Seller Information:</div>
                      <div>
                        <p>
                          <strong>Name:</strong> {selectedRowData.sellerId?.name || "N/A"}
                        </p>
                        <p>
                          <strong>Email:</strong> {selectedRowData.sellerId?.email || "N/A"}
                        </p>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col md={12}>
                      <div className="fw-bold mb-2">Your Request:</div>
                      <div className="bg-light p-3 rounded">
                        <p className="mb-2">{selectedRowData.requestDetails?.message || "No message provided"}</p>
                        {selectedRowData.requestDetails?.suggestedPrice && (
                          <p className="mb-0">
                            <strong>Your Suggested Price:</strong> ${selectedRowData.requestDetails.suggestedPrice}
                          </p>
                        )}
                      </div>

                      {selectedRowData.requestDetails?.attachments &&
                        selectedRowData.requestDetails.attachments.length > 0 && (
                          <div className="mt-3">
                            <div className="fw-bold mb-2">Attachments:</div>
                            {selectedRowData.requestDetails.attachments.map((attachment, index) => (
                              <div key={index} className="d-flex align-items-center mb-2">
                                <i className="fas fa-paperclip me-2"></i>
                                <a href={resolveFileUrl(attachment.fileUrl, config.apiURI)} target="_blank" rel="noopener noreferrer">
                                  {attachment.fileName}
                                </a>
                                <small className="text-muted ms-2">({attachment.fileType})</small>
                              </div>
                            ))}
                          </div>
                        )}

                      {/* Show edit history */}
                      {selectedRowData.buyerEdits && selectedRowData.buyerEdits.length > 0 && (
                        <div className="mt-3">
                          <div className="fw-bold mb-2">Edit History:</div>
                          <div className="bg-warning bg-opacity-10 p-3 rounded">
                            {selectedRowData.buyerEdits.map((edit, index) => (
                              <div key={index} className="mb-2 pb-2 border-bottom">
                                <small className="text-muted">
                                  {new Date(edit.editedAt).toLocaleDateString()} - {edit.reason}
                                </small>
                                {edit.previousPrice && edit.newPrice && (
                                  <div>
                                    <small>
                                      Price changed from ${edit.previousPrice} to ${edit.newPrice}
                                    </small>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </Col>
                  </Row>

                  {selectedRowData.response?.message && (
                    <Row className="mb-4">
                      <Col md={12}>
                        <div className="fw-bold mb-2">Seller Response:</div>
                        <div className="bg-success bg-opacity-10 p-3 rounded border border-success border-opacity-25">
                          <p className="mb-2">{selectedRowData.response.message}</p>
                          {selectedRowData.response.price && (
                            <p className="mb-1">
                              <strong>Quoted Price:</strong> ${selectedRowData.response.price}
                            </p>
                          )}
                          {selectedRowData.response.deliveryTime && (
                            <p className="mb-1">
                              <strong>Delivery Time:</strong> {selectedRowData.response.deliveryTime}
                            </p>
                          )}

                          {/* Show milestones if they exist */}
                          {selectedRowData.response.milestones && selectedRowData.response.milestones.length > 0 && (
                            <div className="mt-3">
                              <strong>Project Milestones:</strong>
                              <div className="mt-2">
                                {selectedRowData.response.milestones.map((milestone, index) => (
                                  <div key={index} className="border rounded p-2 mb-2 bg-white">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <h6 className="mb-1">{milestone.title}</h6>
                                        <p className="mb-1 text-muted small">{milestone.description}</p>
                                      </div>
                                      <div className="text-end">
                                        <div className="fw-bold">${milestone.amount}</div>
                                        <small className="text-muted">{milestone.estimatedDeliveryDays} days</small>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          <small className="text-muted">
                            Responded on:{" "}
                            {new Date(selectedRowData.response.respondedAt).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </small>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* Quote Progress Stepper */}
                  <Row className="mb-4">
                    <Col md={12}>
                      <div className="fw-bold mb-3">Quote Progress:</div>
                      <Box sx={{ width: "100%" }}>
                        <Stepper activeStep={this.getQuoteSteps(selectedRowData.status).activeStep} alternativeLabel>
                          {this.getQuoteSteps(selectedRowData.status).steps.map((label) => (
                            <Step key={label}>
                              <StepLabel>{label}</StepLabel>
                            </Step>
                          ))}
                        </Stepper>
                      </Box>
                    </Col>
                  </Row>

                  <div className="bg-light py-3 px-4 rounded text-center">
                    <small>
                      Quote expires on:{" "}
                      {new Date(selectedRowData.expiresAt).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </small>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* Quote Response Action Modal */}
        <Modal
          show={this.state.showResponseModal}
          onHide={() => this.setState({ showResponseModal: false })}
          dialogClassName="modal-lg"
          aria-labelledby="quote-response-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="quote-response-modal">Quote Response - Action Required</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedRowData && (
              <div>
                <div className="text-center mb-4">
                  <h5>The seller has responded to your quote request!</h5>
                  <p className="text-muted">
                    Review the details below and decide whether to accept or reject this quote.
                  </p>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="card h-100">
                      <div className="card-body">
                        <h6 className="card-title">Item Details</h6>
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              selectedRowData.productId?.featuredImage ||
                              selectedRowData.serviceId?.featuredImage ||
                              "/placeholder.svg"
                            }
                            alt="Item"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                              marginRight: "10px",
                              borderRadius: "6px",
                            }}
                          />
                          <div>
                            <p className="mb-1 fw-bold">
                              {selectedRowData.productId?.name || selectedRowData.serviceId?.name}
                            </p>
                            <small className="text-muted">
                              Original: ${selectedRowData.productId?.price || selectedRowData.serviceId?.charges}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card h-100">
                      <div className="card-body">
                        <h6 className="card-title">Seller's Quote</h6>
                        <div className="text-center">
                          <h3 className="text-success mb-1">${selectedRowData.response?.price || "N/A"}</h3>
                          {selectedRowData.response?.deliveryTime && (
                            <p className="mb-0">
                              <small>Delivery: {selectedRowData.response.deliveryTime}</small>
                            </p>
                          )}
                          {selectedRowData.milestoneCount > 0 && (
                            <Badge bg="info" className="mt-2">
                              {selectedRowData.milestoneCount} Milestones
                            </Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {selectedRowData.response?.message && (
                  <div className="mb-4">
                    <h6>Seller's Message:</h6>
                    <div className="bg-light p-3 rounded">
                      <p className="mb-0">{selectedRowData.response.message}</p>
                    </div>
                  </div>
                )}

                {/* Show milestones breakdown if available */}
                {selectedRowData.response?.milestones && selectedRowData.response.milestones.length > 0 && (
                  <div className="mb-4">
                    <h6>Project Milestones:</h6>
                    <div className="bg-light p-3 rounded">
                      {selectedRowData.response.milestones.map((milestone, index) => (
                        <div key={index} className="border rounded p-3 mb-2 bg-white">
                          <div className="d-flex justify-content-between align-items-start">
                            <div className="flex-grow-1">
                              <h6 className="mb-1">{milestone.title}</h6>
                              <p className="mb-1 text-muted">{milestone.description}</p>
                              <small className="text-muted">
                                Estimated delivery: {milestone.estimatedDeliveryDays} days
                              </small>
                            </div>
                            <div className="text-end">
                              <h5 className="mb-0 text-success">${milestone.amount}</h5>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="text-end mt-2">
                        <strong>Total: ${selectedRowData.response.price}</strong>
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-center gap-3">
                  <Button
                    variant="outline-danger"
                    onClick={() => this.handleRejectClick(selectedRowData._id)}
                    disabled={actionLoading}
                  >
                    {actionLoading ? "Processing..." : "Reject Quote"}
                  </Button>
                  <Button
                    className="btn_yellow_2"
                    onClick={() => this.handleAcceptQuote(selectedRowData._id)}
                    disabled={actionLoading}
                  >
                    {actionLoading ? "Processing..." : "Accept Quote"}
                  </Button>
                </div>

                <div className="text-center mt-3">
                  <small className="text-muted">
                    By accepting this quote, you agree to proceed with the purchase at the quoted price and terms.
                    {selectedRowData.response?.milestones && selectedRowData.response.milestones.length > 0 && (
                      <> The project will be broken down into the milestones shown above.</>
                    )}
                  </small>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* Edit Quote Modal */}
        <QuoteRequestModal
          show={this.state.showEditModal}
          onHide={() => this.setState({ showEditModal: false })}
          productId={selectedRowData?.productId?._id}
          serviceId={selectedRowData?.serviceId?._id}
          sellerId={selectedRowData?.sellerId?._id}
          itemName={selectedRowData?.productId?.name || selectedRowData?.serviceId?.name}
          itemImage={selectedRowData?.productId?.featuredImage || selectedRowData?.serviceId?.featuredImage}
          itemPrice={selectedRowData?.productId?.price || selectedRowData?.serviceId?.charges}
          existingQuote={selectedRowData}
          isEditing={true}
          onSuccess={(newQuoteId) => {
            if (newQuoteId) {
              this.props.history.replace({
                pathname: "/my-quotes",
                search: `?quoteId=${newQuoteId}`,
              })
            }
            this.getQuoteDetails()
          }}
        />

        {/* Timeline Modal */}
        <QuoteTimelineModal
          show={this.state.showTimelineModal}
          onHide={() => this.setState({ showTimelineModal: false })}
          quoteId={selectedRowData?._id}
          role="buyer"
        />

        {/* Reject Quote Confirmation Modal */}
        <Modal
          show={this.state.showRejectModal}
          onHide={this.handleCancelReject}
          dialogClassName="modal-md"
          aria-labelledby="reject-quote-modal"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title id="reject-quote-modal">
              <i className="fas fa-exclamation-triangle text-warning me-2"></i>
              Confirm Quote Rejection
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center mb-4">
              <h5>Are you sure you want to reject this quote?</h5>
              <p className="text-muted">
                This action cannot be undone. Please provide a reason for rejecting this quote.
              </p>
            </div>

            {selectedRowData && (
              <div className="mb-4">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          selectedRowData.productId?.featuredImage ||
                          selectedRowData.serviceId?.featuredImage ||
                          "/placeholder.svg"
                        }
                        alt="Item"
                        style={{
                          width: "50px",
                          height: "50px",
                          objectFit: "cover",
                          marginRight: "10px",
                          borderRadius: "6px",
                        }}
                      />
                      <div>
                        <h6 className="mb-1">{selectedRowData.productId?.name || selectedRowData.serviceId?.name}</h6>
                        <p className="mb-0 text-muted">Quote ID: {selectedRowData.quoteCode}</p>
                        <p className="mb-0 fw-bold text-success">Quoted Price: ${selectedRowData.response?.price}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="mb-3">
              <label htmlFor="rejectionReason" className="form-label">
                <strong>Reason for Rejection *</strong>
              </label>
              <textarea
                id="rejectionReason"
                className="form-control"
                rows="4"
                placeholder="Please explain why you are rejecting this quote (minimum 5 characters)..."
                value={this.state.rejectionReason}
                onChange={(e) => this.setState({ rejectionReason: e.target.value })}
                maxLength="500"
              />
              <div className="form-text">
                {this.state.rejectionReason.length}/500 characters
                {this.state.rejectionReason.length < 5 && (
                  <span className="text-danger ms-2">(Minimum 5 characters required)</span>
                )}
              </div>
            </div>

            <div className="alert alert-warning">
              <i className="fas fa-info-circle me-2"></i>
              <strong>Note:</strong> Once rejected, this quote will be marked as final and cannot be modified. You can
              create a new quote request if needed.
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCancelReject} disabled={actionLoading}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={this.handleConfirmReject}
              disabled={actionLoading || this.state.rejectionReason.trim().length < 5}
            >
              {actionLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Rejecting...
                </>
              ) : (
                <>
                  <i className="fas fa-times me-2"></i>
                  Confirm Rejection
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}

export default withRouter(connect(setLoading)(MyQuotes))
